// Tiny Web Audio click/swoop for card flip & message send.
let ctx = null;
function getCtx() {
    if (typeof window === "undefined") return null;
    if (ctx) return ctx;
    try {
        const Ctx = window.AudioContext || window.webkitAudioContext;
        if (!Ctx) return null;
        ctx = new Ctx();
        return ctx;
    } catch (e) {
        return null;
    }
}

export function playFlipSound() {
    const c = getCtx();
    if (!c) return;
    try {
        const o = c.createOscillator();
        const g = c.createGain();
        o.type = "sine";
        const t = c.currentTime;
        o.frequency.setValueAtTime(540, t);
        o.frequency.exponentialRampToValueAtTime(180, t + 0.18);
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(0.18, t + 0.02);
        g.gain.exponentialRampToValueAtTime(0.0001, t + 0.22);
        o.connect(g);
        g.connect(c.destination);
        o.start(t);
        o.stop(t + 0.25);
    } catch (e) { /* noop */ }
}

export function playPopSound() {
    const c = getCtx();
    if (!c) return;
    try {
        const o = c.createOscillator();
        const g = c.createGain();
        o.type = "triangle";
        const t = c.currentTime;
        o.frequency.setValueAtTime(820, t);
        o.frequency.exponentialRampToValueAtTime(620, t + 0.08);
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(0.12, t + 0.01);
        g.gain.exponentialRampToValueAtTime(0.0001, t + 0.12);
        o.connect(g);
        g.connect(c.destination);
        o.start(t);
        o.stop(t + 0.14);
    } catch (e) { /* noop */ }
}

export function playDingSound() {
    const c = getCtx();
    if (!c) return;
    try {
        const o = c.createOscillator();
        const g = c.createGain();
        o.type = "sine";
        const t = c.currentTime;
        o.frequency.setValueAtTime(880, t);
        o.frequency.exponentialRampToValueAtTime(1180, t + 0.18);
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(0.14, t + 0.02);
        g.gain.exponentialRampToValueAtTime(0.0001, t + 0.32);
        o.connect(g);
        g.connect(c.destination);
        o.start(t);
        o.stop(t + 0.35);
    } catch (e) { /* noop */ }
}
